import React from 'react'
import {FieldGuesser, ShowGuesser} from '@api-platform/admin'
import {TextField, NumberField, ReferenceField} from 'react-admin';
import {useTranslation} from "react-i18next";

function Show(props) {
    const {t} = useTranslation()
    return (
        <ShowGuesser {...props}>
            <TextField source="originId" label={t('id')}/>
            <TextField source="name" label={t('common.name')}/>
            <ReferenceField source="company" reference="dictionary/companies" link={false} label={t('brief.company')}
                            sortable={false}>
                <TextField source="name"/>
            </ReferenceField>
            <NumberField source="mpmId" label={'mpmId'}/>
        </ShowGuesser>
    )
}

export default Show
